export function convertToPopperPlacement(placement, secondaryPlacement) {
    if (placement === void 0) { placement = 'top'; }
    if (!secondaryPlacement || secondaryPlacement === 'middle') {
        return placement;
    }
    return placement + "-" + secondaryPlacement;
}
export function convertFromPopperPlacement(popperPlacement) {
    if (popperPlacement === void 0) { popperPlacement = 'top'; }
    var _a = popperPlacement.split('-'), placement = _a[0], _b = _a[1], secondaryPlacement = _b === void 0 ? 'middle' : _b;
    return {
        placement: placement,
        secondaryPlacement: secondaryPlacement,
    };
}
//# sourceMappingURL=helpers.js.map